import React from 'react'
import CompanyDetailsStyles from './CompanyDetails.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'

import DeleteConformation from '../DeleteConformation/DeleteConformation';
import useToast from '../../hooks/useToast';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';

const CompanyDetails = () => {

    // get data from redux
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const [tempData, setTempData] = useState(null);

    const [deleteModal, setDeleteModal] = useState(false);
    const dispatch = useDispatch()
    const [data, setData] = useState([])

    const getCompanyData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/companydetails/getAllCompanyDetails`
            )
            setData(res.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getCompanyData()
    }, [])

    const handleDeleteCompanyDetail = async () => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_COSMOSADMIN}/companydetails/deleteById/${tempData.pdfId}`
            ).then((res) => {
                showToast("success", "CompanyDetail Delete Successfully");
                handleDeleteModal();
                getCompanyData();
            })
            

            dispatch(setNotificationCount({
                count: count + 1,
            }))

            // alert('Delete Successful!')
            // window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }




    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }


    return (
        <>
            <Toast />
            <useBackdrop />
            <div className={CompanyDetailsStyles.companyDetailsMain}>
                <div className={CompanyDetailsStyles.companyDetailsContent}>
                    <div className={CompanyDetailsStyles.companyDetailsHeader}>
                        <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' }} >
                            Company Details
                        </Typography>
                        <Link to='/adddetail'>
                            <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add Detail</Button>
                        </Link>
                    </div>
                    <Box className={CompanyDetailsStyles.companyDetailsComponent}>
                        <div className={CompanyDetailsStyles.companyDetailsComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Name
                            </Typography>
                        </div>
                        <div className={CompanyDetailsStyles.companyDetailsComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Last modified
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Action
                            </Typography>
                        </div>
                    </Box>
                    {data.map((detail) =>
                        <Box className={CompanyDetailsStyles.companyDetailsComponent}>
                            <div className={CompanyDetailsStyles.companyDetailsComponentLeft}>
                                <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                    {detail.companyDetails?.companyDetailsHeading}
                                </Typography>
                            </div>
                            <div className={CompanyDetailsStyles.companyDetailsComponentRight}>
                                <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                    {detail.companyDetails?.date}
                                </Typography>
                                <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                    <Link to={`/editdetail/${detail?.pdfId}`} state={detail}>
                                        <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </Link>
                                    <IconButton disableRipple onClick={() => handleDeleteModal(detail)}>
                                        <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </IconButton>
                                </Typography>
                            </div>
                        </Box>
                    )}
                </div>
            </div>


            <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => handleDeleteCompanyDetail()}

                onReject={() => { }}
            >
                <h2>Delete Condition</h2>
                <p>Are you sure you want to Delete this Condition?</p>

            </DeleteConformation>
        </>

    )
}

export default CompanyDetails